// src/redux/packageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedPackage: null,
  isConfirmBooked: false,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    // setSelectedPackage: (state, action) => {
    //   state.selectedPackage = action.payload;
    // },
    // clearSelectedPackage: (state) => {
    //   state.selectedPackage = null;
    // },
    setIsConfirmBooked:(state,action)=>{
      state.isConfirmBooked=action.payload;
    }

  },
});

export const { setIsConfirmBooked } = bookingSlice.actions;
export default bookingSlice.reducer;
